import React from 'react'
import { RotatingLines } from 'react-loader-spinner';
import { currency, getBodyType } from '../../../../../common/services/common.service';

export default function ModalQuotesDetailsComponent({
    handleBookLater, selectedVehicleItem, dropLocations, pickupLocations, quoteDetails, enablePlaceOrder, handlePayment, isLoading, paymentSettings, paymentSelectedInput, handlePaymentInput }: any) {

    const items = [
        {
            name: 'Cash',
            description: 'Cash on delivery',
            value: 10,
            checked: '',
            // imageUrl: require('../../../../assets/img/cash.png'),
            show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForCOD,

        },
        {
            name: 'Online',
            description: 'Payment gateway',
            value: 20,
            checked: 'checked',
            // imageUrl: require('../../../../assets/img/ccAvenue.png'),
            show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForOnline,
        },
        {
            name: 'Wallet',
            description: 'Wallet',
            value: 40,
            checked: '',
            // imageUrl: require('../../../../assets/img/wallet.png'),

        },
    ];

    return (

        <div className="w-full p-4 bg-white min-h-screen">
            {/* Heading */}
            <h1 className="text-lg md:text-xl font-semibold mb-6 text-center">Confirm Order</h1>

            {/* Order Details */}
            <div className="mb-3 bg-gray-50 rounded-xl p-2 shadow-sm">
                <h2 className="text-base md:text-lg font-semibold mb-4">Order Details</h2>
                <div className="space-y-3">
                    <div>
                        <label className="text-sm font-medium text-gray-800">Vehicle Type</label>
                        <p className="text-sm text-gray-600">{getBodyType(selectedVehicleItem?.VehicleBodyTypeId)}</p>
                    </div>
                    <div>
                        <label className="text-sm font-medium text-gray-800">Total Distance</label>
                        <p className="text-sm text-gray-600">
                            {quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance} km
                        </p>
                    </div>
                    <div>
                        <label className="text-sm font-medium text-gray-800">Amount Quoted</label>
                        <p className="text-sm text-gray-600">
                            ₹ {quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value}
                        </p>
                    </div>
                </div>

                <div className="my-4 border-b border-gray-200" />

                <div className="space-y-3">
                    <div>
                        <label className="text-sm font-medium text-gray-800">Pickup Address</label>
                        <p className="text-sm text-gray-600">{pickupLocations?.description}</p>
                    </div>
                    <div>
                        <label className="text-sm font-medium text-gray-800">Drop Address</label>
                        <p className="text-sm text-gray-600">{dropLocations?.description}</p>
                    </div>
                </div>
            </div>

            {/* Payment Details */}
            <div className="mb-3 bg-gray-50 rounded-xl p-2 shadow-sm">
                <h2 className="text-base md:text-lg font-semibold mb-4">Payment Details</h2>
                <p className="text-sm font-medium text-gray-800 mb-2">Payment Method</p>

                <div className="flex flex-col space-y-3">
                    {items?.map(
                        (item, index) =>
                            item.show && (
                                <label
                                    key={index}
                                    className="flex items-center bg-white border rounded-lg px-3 py-2 shadow-sm cursor-pointer hover:bg-gray-100"
                                >
                                    <input
                                        type="radio"
                                        name="paymentMethod"
                                        checked={paymentSelectedInput == String(item?.name)}
                                        onChange={(event: any) => handlePaymentInput(event, item)}
                                        value={item?.name}
                                        className="mr-3 accent-primary cursor-pointer"
                                    />
                                    <span className="text-sm text-gray-700">{item?.name}</span>
                                </label>
                            )
                    )}
                </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col space-y-3">
                <button
                    onClick={handleBookLater}
                    className="w-full px-4 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 text-sm font-medium"
                >
                    Book Later
                </button>

                <button
                    onClick={handlePayment}
                    disabled={!enablePlaceOrder || isLoading}
                    className={`w-full px-4 py-3 text-white rounded-lg text-sm font-medium flex items-center justify-center relative
        ${paymentSelectedInput === 'Cash' ? '' : ''}
        ${isLoading ? 'bg-gray-400 cursor-not-allowed' : enablePlaceOrder ? 'bg-primary hover:bg-slate-500' : 'bg-slate-400 cursor-not-allowed'}`}
                >
                    {paymentSelectedInput === 'Cash' ? 'Place Order' : 'Make a Payment'}
                    {isLoading && (
                        <span className="absolute right-6">
                            <RotatingLines
                                visible={true}
                                width={'20'}
                                strokeColor="#fff"
                                strokeWidth="6"
                                animationDuration="0.75"
                                ariaLabel="rotating-lines-loading"
                            />
                        </span>
                    )}
                </button>
            </div>
        </div>






    )
}